import RegistrationBewarePage from 'mutation/components/registration-beware';
import { Fragment } from 'react';

const ManagementAnomalyPage = (): React.ReactElement => {
  return (
    <Fragment>
      <RegistrationBewarePage title="Gestione Anomalie" />
    </Fragment>
  );
};

ManagementAnomalyPage.displayName = 'Management Anomaly page component';

export default ManagementAnomalyPage;
